module.exports = "../../fonts/vendor/@mdi/materialdesignicons-webfont.ttf?ac55aef662342c261b21af3611b5e746";